var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"md":"10 ml-content"}},[_c('app-carousel'),_c('a',{staticClass:"anchor",attrs:{"id":"microlibrary"}}),_c('div',{staticClass:"postcontent",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }